import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DropdownToggleDirective } from 'src/app/shared/directives/dropdown-toggle.directive';
import { ErrorHandleService } from 'src/app/shared/services/error-handle/error-handle.service';
import { environment } from 'src/environments/environment';
import { FiltroBuscaService } from '../service/filtro-busca-service/filtro-busca.service';
import { ResultadoFiltroService } from '../service/resultado-service/resultado-filtros.service';

@Component({
  selector: 'app-filtro-busca-salva-industrial',
  standalone: true,
  imports: [CommonModule, FormsModule, DropdownToggleDirective],
  templateUrl: './filtro-busca-salva-industrial.component.html',
  styleUrls: ['./filtro-busca-salva-industrial.component.scss'],
})
export class FiltroBuscaSalvaIndustrialComponent implements OnInit {
  get buscaIds(): string {
    return Array.isArray(this.buscas)
      ? this.buscas.map((b) => b.searchID).join(', ')
      : '';
  }
  BASE_IMG_URL: string = environment.BASE_IMG_URL;

  buscas: any[] = [];
  selectedBuscaId: number = 0;

  @Input() idModuloSelecionado: number;
  @Input() buscaSelecionada: number = 0;
  @Output() buscaSalvaChange = new EventEmitter<number>();

  private isInitializing = true;

  constructor(
    private readonly _filtroBuscaService: FiltroBuscaService,
    private _errorHandleService: ErrorHandleService,
    private _resultadoFiltroBusca: ResultadoFiltroService
  ) {}

  ngOnInit() {
    this.isInitializing = true;

    this.carregarBuscasSalvas().then(() => {
      if (this.buscaSelecionada > 0) {
        this.selectedBuscaId = this.buscaSelecionada;
      }

      this.isInitializing = false;
    });
  }

  ngOnChanges(changes: any) {
    if (changes.buscaSelecionada) {
      const novoValor = changes.buscaSelecionada.currentValue;

      if (!novoValor || novoValor === 0) return;

      this.buscaSelecionada = novoValor;

      if (!this.isInitializing && this.buscas.length > 0) {
        this.selectedBuscaId = novoValor;
      }
    }

    if (
      changes.idModuloSelecionado &&
      !changes.idModuloSelecionado.firstChange
    ) {
      this.isInitializing = true;

      this.carregarBuscasSalvas().then(() => {
        this.isInitializing = false;

        if (this.buscaSelecionada > 0) {
          this.selectedBuscaId = this.buscaSelecionada;
        }
      });
    }
  }

  carregarBuscasSalvas(): Promise<void> {
    return new Promise((resolve) => {
      if (!this.idModuloSelecionado) {
        this.buscas = [];
        return resolve();
      }

      this._filtroBuscaService
        .listaBuscasSalvasIndustrial(this.idModuloSelecionado)
        .subscribe({
          next: (res: any) => {
            this.buscas = res.data || [];

            if (
              this.buscaSelecionada > 0 &&
              this.buscas.some((b) => b.searchID === this.buscaSelecionada)
            ) {
              this.selectedBuscaId = this.buscaSelecionada;
            }

            resolve();
          },
          error: () => {
            this.buscas = [];
            resolve();
          },
        });
    });
  }

  public setSelectedBusca(buscaId: number, silent?: boolean) {
    this.selectedBuscaId = buscaId;
    this.buscaSelecionada = buscaId;

    if (!silent) {
      this.buscaSalvaChange.emit(buscaId);
    }
  }

  onBuscaSelecionadaChange(buscaId: number) {
    if (this.isInitializing) return;

    const buscaIdNum = Number(buscaId) || 0;
    this.selectedBuscaId = buscaIdNum;
    this.buscaSelecionada = buscaIdNum;

    if (!buscaIdNum || buscaIdNum === 0) {
      this.buscaSalvaChange.emit(0);
      return;
    }

    this._resultadoFiltroBusca
      .resultadoBuscaSalvaIndustrial(buscaIdNum, this.idModuloSelecionado)
      .subscribe({
        next: () => {
          this.buscaSalvaChange.emit(buscaIdNum);
        },
        error: (error) => console.error(error),
      });
  }

  trackByBusca(index: number, busca: any): number {
    return busca.searchID;
  }
}
